// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-card[data-v-dd54841a]{padding:4px;padding-bottom:7px}.img-attachment[data-v-dd54841a]{width:70px;height:70px;border-radius:7px;-o-object-fit:cover;object-fit:cover}.icon-attachment[data-v-dd54841a]{font-size:50px;border-radius:7px}", ""]);
// Exports
module.exports = exports;
